import { getFilterQueryStringWithoutArray } from "@/helpers/helper.js";
import { BASE_URL } from "@/service_urls";
import campaign from '@/services/campaign';

const state = {
    campaignById: {},
    campaigns: [],
    campaignFields: [],
    campaignFieldsData: [],
    campaignsCount: 0,
    fromCampaignPage: false,
    candidateData: {},
    regCompletedCandidate: {},
    campaignWelcomeDetails: {},
    campaignBookmarks: [],
    candidateCampaigns: {},
    candidateCampaignsCount: 0,
    candidateCampaignInfo: {}
};

const getters = {
    getCampaignById: state => state.campaignById,
    getCampaigns: state => state.campaigns,
    getCampaignFields: state => state.campaignFields,
    campaignFieldsData: state => state.campaignFieldsData,
    getCampaignsCount: state => state.campaignsCount,
    fromCampaignPage: state => state.fromCampaignPage,
    getCandidateData: state => state.candidateData,
    getCampaignWelcomeDetails: state => state.campaignWelcomeDetails,
    getCampaignBookmarks: state => state.campaignBookmarks,
    getCandidateCampaigns: state => state.candidateCampaigns,
    getCandidateCampaignsCount: state => state.candidateCampaignsCount,
    getCandidateCampaignInfo: state => state.candidateCampaignInfo,
};

const actions = {
    fetchCampaignById({ commit }, campaign_id) {
        return campaign.fetchCampaignById(campaign_id)
            .then(res => {
                const { data } = res
                commit("SET_CAMPAIGN_BY_ID", data);
                return data;
            })
            .catch(err => {
                console.log("Error while fetching campaigns", err)
                return err
            })
    },
    fetchCampaigns({ commit, getters }, payload = {}) {
        const { getCustomerId, getOrgID } = getters;
        const { searchTerm, skip, limit, is_active } = payload;
        let queryPayload = {
            all_rows: false,
            fetch_row_count: false,
            customer_id: getCustomerId,
        }
        if (searchTerm) {
            queryPayload = { ...queryPayload, searchTerm };
        }
        if (skip !== undefined) {
            queryPayload = { ...queryPayload, skip };
        } else {
            queryPayload = { ...queryPayload, skip: 0 };
        }
        if (limit) {
            queryPayload = { ...queryPayload, limit };
        }
        if (getOrgID) {
            queryPayload = { ...queryPayload, organisation_id: getOrgID }
        }
        if (is_active !== undefined) {
            queryPayload = { ...queryPayload, is_active };
        }
        const query = getFilterQueryStringWithoutArray(queryPayload)
        return campaign.fetchCampaigns(query)
            .then(res => {
                const { data } = res
                commit("SET_CAMPAIGNS", data);
                return data;
            })
            .catch(err => {
                console.log("Error while fetching campaigns", err)
                return err
            })
    },
    fetchCampaignFields({ commit }, campaign_id) {
        return campaign.fetchCampaignFields(campaign_id)
            .then(res => {
                const { data } = res
                commit("SET_CAMPAIGN_FIELDS", data);
                return data;
            })
            .catch(err => {
                console.log("Error while fetching campaigns", err)
                return err
            })
    },
    createCampaignTransactions({ dispatch, getters }, { campaign_id, candidate_uid, completed, payload, queryPayload }) {
        const {getCampaignById} = getters
        const uuid = getCampaignById?.campaign_uuid
        let queryData = {
            campaign_id,
            uuid,
            ...queryPayload,
        }
        if (completed !== null) {
            queryData.completed = completed;
        }
        if(candidate_uid){
            queryData = {
                ...queryData,
                candidate_uid
            }
        }
        const queryString = getFilterQueryStringWithoutArray(queryData)
        let url = `${BASE_URL}/campaign_transactions/?${queryString}`;

        return campaign.createCampaignTransactions(url, payload)
            .then(res => {
                const { data } = res
                dispatch("showToast", { class: 'bg-success text-white', message: 'Registered Successfully' })
                return res;
            })
            .catch(err => {
                const message = "Error While Submit Campaign Form";
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                console.log(message, err);
                return err
            })
    },
    registerCampaign: ({ getters, commit, dispatch }, payload) => {
        const {
            campaign_name,
            customer_id,
            organisation_id,
            logo,
            background_image,
            campaign_registration_required,
            description,
            welcome_text,
            campaign_candidate_email_id,
            customer_organisation_id,
            campaign_information
        } = payload;

        let queryPayload = { campaign_name, customer_id, campaign_registration_required, customer_organisation_id };
        if (organisation_id) {
            queryPayload = { ...queryPayload, organisation_id }
        }
        if (description) {
            queryPayload = { ...queryPayload, description }
        }
        if (welcome_text) {
            queryPayload = { ...queryPayload, welcome_text }
        }
        if (campaign_candidate_email_id) {
            queryPayload = { ...queryPayload, campaign_candidate_email_id }
        }

        const queryString = getFilterQueryStringWithoutArray(queryPayload);

        const formData = new FormData();
        if(campaign_information) {
            formData.append("campaign_information", campaign_information); 
        }
        if (logo) {
            const { file, fileName } = logo
            formData.append("logo", file, fileName);
        } else {
            formData.append("logo", '')
        }
        if (background_image) {
            const { file, fileName } = background_image
            formData.append("background_image", file, fileName);
        } else {
            formData.append("background_image", '')
        }

        return campaign
            .registerCampaign(queryString, formData)
            .then((res) => {
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Created Campaign Form Successfully",
                });
                return res.data;
            })
            .catch((err) => {
                const message = err?.response?.status == 409 ? err?.response?.data?.detail : "Error While Create Campaign Form"
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                console.log("Error While Create Campaign Form", err);
                return err;
            });
    },
    initCampaign: ({ getters, commit, dispatch }, campaign_id) => {
        const { questionTypes } = getters;
        let appendAction = [];
        commit("SET_FETCHING", true);
        if (!questionTypes.length)
            appendAction = [...appendAction, dispatch("fetchQuestionTypes", true)];
        Promise.all(appendAction).then(res => {
            commit("SET_FETCHING", false);
            return res;
        });
    },
    createCampaignField: ({ getters, commit, dispatch }, data) => {
        const { payload, campaign_id } = data;
        return campaign
            .createCampaignField(campaign_id, payload)
            .then((res) => {
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Pre-screening question(s) created successfully",
                });
                return res;
            })
            .catch((err) => {
                const message = err.response.data.detail
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                console.log(message, err);
                return err;
            });
    },
    updateCampaignField: ({ getters, commit, dispatch }, data) => {
        const { payload, campaign_id } = data;
        return campaign
            .updateCampaignField(campaign_id, payload)
            .then((res) => {
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Pre-screening question(s) updated successfully",
                });
                return res;
            })
            .catch((err) => {
                const message = "Error While Updated Campaign Field"
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                console.log(message, err);
                return err;
            });
    },
    updateCampaignData: ({ dispatch }, payload) => {
        const { logo, background_image, campaign_uuid, campaign_information, ...rest } = payload;

        const queryString = getFilterQueryStringWithoutArray({ ...rest });

        let formData = null;
        formData = new FormData();
        if(campaign_information) {
            formData.append("campaign_information", campaign_information); 
        }
        if ((logo && logo.file) || (background_image && background_image.file)) {
            if (logo) {
                const { file, fileName } = logo;
                formData.append("logo", file, fileName);
            }
            if (background_image) {
                const { file, fileName } = background_image;
                formData.append("background_image", file, fileName);
            }
        }
        return campaign
            .updateCampaignData(campaign_uuid, queryString, formData)
            .then((res) => {
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Campaign updated successfully",
                });
                return res;
            })
            .catch((err) => {
                const message = err.response.data.detail;
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                console.log(message, err);
                return err;
            });
    },
    deleteCampaignField({ dispatch }, campaign_field_id) {
        dispatch("showLoader")
        return campaign
            .deleteCampaignField(campaign_field_id)
            .then((response) => {
                dispatch("hideLoader")
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Pre-screening question(s) deleted successfully",
                });
                return response;
            })
            .catch((error) => {
                dispatch("hideLoader")
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message: "Error While Deleting Campaign Field",
                });
                console.log("Error While Deleting Campaign Field", error);
                return error;
            });
    },
    setCampaignFieldsData: ({ commit }, payload) => {
        commit("SET_FROM_CAMPAIGN_PAGE", true);
        commit("SET_CAMPAIGN_FIELDS_DATA", payload);
    },
    clearCampaignFieldsData({ commit }) {
        commit("CLEAR_CAMPAIGN_FIELDS_DATA");
    },
    downloadCampaignData({ dispatch }, { campaign_name, campaign_id, }) {
        dispatch("showFixedToast", {
            class: 'bg-secondary text-white',
            message: 'Preparing to Download...'
        });
        return campaign.downloadCampaignData(campaign_id)
            .then(res => {
                const fileName = `${campaign_name}.xlsx`;
                const link = document.createElement("a");
                const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    dispatch("hideFixedToast");
                } else {
                    dispatch("hideFixedToast");
                    dispatch("showToast", {
                        class: 'bg-danger text-white',
                        message: 'Your browser does not support downloading files.'
                    });
                }
            })
            .catch(err => {
                dispatch("hideFixedToast");
                dispatch("showToast", {
                    class: 'bg-danger text-white',
                    message: 'Download failed. Please try again.'
                });
                console.error("Error in downloading campaign data:", err);
                return err;
            });
    },
    fetchCampaignsCount({ commit, getters }, payload = {}) {
        const { getCustomerId, getOrgIDFromAccessToken } = getters;
        const { searchTerm, is_active } = payload;
        let queryPayload = {
            all_rows: true,
            fetch_row_count: true,
            customer_id: getCustomerId,
            organisation_id: getOrgIDFromAccessToken,
        }
        if (searchTerm) {
            queryPayload = { ...queryPayload, searchTerm };
        }
        if (is_active !== undefined) {
            queryPayload = { ...queryPayload, is_active };
        }
        const query = getFilterQueryStringWithoutArray(queryPayload)
        return campaign.getCampaignsCount(query)
            .then(res => {
                const { data } = res
                commit("SET_CAMPAIGNS_COUNT", data);
                return data;
            })
            .catch(err => {
                console.log("Error while fetching campaigns count", err)
                return err
            })

    },
    getCampaignsByEmail({ commit, getters }, payload) {
        let { email, ...rest } = payload
        let query = getFilterQueryStringWithoutArray({ email: encodeURIComponent(email), ...rest })
        return campaign.getCampaignsByEmail(query)
            .then(res => {
                return res.data
            })
            .catch(err => {
                console.log("Error while fetching campaigns by email", err)
                return err
            })
    },
    getCampaignsDataByCampaignUserID({ commit, getters }, payload) {
        const query = getFilterQueryStringWithoutArray(payload)
        return campaign.getCampaignsDataByCampaignUserID(query)
            .then(res => {
                const { data } = res
                commit("SET_CAMPAIGN_FIELDS_DATA", data);
                return res.data
            })
            .catch(err => {
                console.log("Error while fetching campaigns by email", err)
                return err
            })
    },
    checkCandidateExistInCampaign({ commit }, payload) {
        const { email, campaign_id } = payload;
        let queryString = ''
        if (campaign_id) {
            queryString = getFilterQueryStringWithoutArray({ campaign_id, email: encodeURIComponent(email) });
        } else {
            queryString = getFilterQueryStringWithoutArray({ email: encodeURIComponent(email) });
        }
        return campaign.checkCandidateExistInCampaign({ queryString })
            .then(res => {
                const { data } = res
                commit("SET_CANDIDATE_DATA", data);
                return res.data
            })
            .catch(err => {
                console.log("Error while checking candidate exist in candidate or campaign", err)
                return err
            })
    },
    updateCampaignPreRegCompleted({ commit }, payload) {
        const { email, updated_by } = payload;
        let queryString = ''
        if (updated_by) {
            queryString = getFilterQueryStringWithoutArray({ updated_by, email: encodeURIComponent(email) });
        } else {
            queryString = getFilterQueryStringWithoutArray({ email: encodeURIComponent(email) });
        }
        return campaign.updateCampaignPreRegCompleted({ queryString })
            .then(res => {
                const { data } = res
                return data
            })
            .catch(err => {
                console.log(`Error while update "completed" in campaign_pre_reg`, err)
                return err
            })
    },
    addCampaignBookmark({ commit, dispatch, getters }, payload) {
        const { getCustomerId, getOrgIDFromAccessToken } = getters;
        payload = {
            customer_uid: getCustomerId,
            organisation_id: getOrgIDFromAccessToken,
            ...payload
        }
        payload
        return campaign.addCampaignBookmark({ payload })
            .then(res => {
                const { data } = res
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Added to campaign bookmark successfully",
                });
                return data
            })
            .catch(err => {
                const message = err.response?.data?.detail || "Error while adding bookmark"
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err
            })
    },
    fetchCampaignBookmarks({ commit, getters }) {
        let queryString = ''
        const { getOrgIDFromAccessToken } = getters;
        queryString = getFilterQueryStringWithoutArray({ organisation_id: getOrgIDFromAccessToken });
        return campaign.getCampaignBookmarks(queryString)
            .then(res => {
                let data = res.data || []
                commit("SET_CAMPAIGN_BOOKMARKS", data)
                return data
            })
            .catch(err => {
                const message = "Error while fetching all bookmarks"
                return err
            })
    },
    sendEnquiry({ commit, dispatch, getters }, payload) {
        dispatch("showLoader")
        return campaign.sendEnquiry({ payload })
            .then(res => {
                const { data } = res
                dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Enquiry sent successfully",
                });
                return data
            })
            .catch(err => {
                const message = err.response?.data?.detail || "Error while sending enquiry"
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err
            })
    },
    fetchCandidateCampaigns({ commit, getters }, payload) {
        const { getCandidateId: candidate_uid, getOrgIDFromAccessToken: organisation_id } = getters;
        const { skip=0, limit=10 } = payload || {};

        const queryString = getFilterQueryStringWithoutArray({ candidate_uid, organisation_id, skip, limit });
        return campaign.getCandidateCampaigns({ queryString })
            .then(res => {
                const { data } = res;
                commit("SET_CANDIDATE_CAMPAIGNS", data);
                return data
            })
            .catch(err => {
                const message = "Error while fetching candidate campaigns"
                console.log(message, err)
                return err
            })
    },
    fetchCandidateCampaignsCount({ commit, getters }) {
        const { getCandidateId: candidate_uid, getOrgIDFromAccessToken: organisation_id } = getters;
        const queryString = getFilterQueryStringWithoutArray({ candidate_uid, organisation_id, count: true });
        return campaign.getCandidateCampaignsCount({queryString})
            .then(res => {
                const { data } = res;
                 commit("SET_CANDIDATE_CAMPAIGNS_COUNT", data);
                return data
            })
            .catch(err => {
                console.error("Error while fetching candidate campaigns count", err)
                return err
            })
    },
    addCampaignCandidate({ getters, commit }, payload) {
        const { campaign_id } = payload;
        payload = {
            campaign_id,
            candidate_uid: getters.getCandidateId,
        }
        return campaign.addCampaignCandidate(payload)
            .then(res => {
                commit("SET_CANDIDATE_CAMPAIGN_INFO", res.data);
                return res
            })
            .catch(err => {
                console.error("Error while adding campaign candidate", err)
                return err
            })
    }
};

const mutations = {
    ["SET_CAMPAIGN_BY_ID"](state, payload) {
        state.campaignById = payload;
    },
    ["SET_CAMPAIGNS"](state, payload) {
        state.campaigns = payload;
    },
    ["SET_CAMPAIGN_FIELDS"](state, payload) {
        state.campaignFields = payload;
    },
    ["SET_CAMPAIGN_FIELDS_DATA"](state, payload) {
        state.campaignFieldsData = payload;
    },
    ["SET_FROM_CAMPAIGN_PAGE"](state, payload) {
        state.fromCampaignPage = payload;
    },
    ["CLEAR_CAMPAIGN_FIELDS_DATA"](state) {
        state.campaignFieldsData = {};
        state.fromCampaignPage = false;
    },
    ["SET_CAMPAIGNS_COUNT"](state, payload) {
        state.campaignsCount = payload;
    },
    ["SET_CANDIDATE_DATA"](state, payload) {
        state.candidateData = payload;
    },
    ["SET_CAMPAIGN_WELCOME_DATA"](state, payload) {
        state.campaignWelcomeDetails = payload;
    },
    ["SET_CAMPAIGN_BOOKMARKS"](state, payload) {
        state.campaignBookmarks = payload;
    },
    ["SET_CANDIDATE_CAMPAIGNS"](state, payload) {
        state.candidateCampaigns = payload;
    },
    ["SET_CANDIDATE_CAMPAIGNS_COUNT"](state, payload) {
        state.candidateCampaignsCount = payload?.total_campaign_count || 0;
    },
    ["SET_CANDIDATE_CAMPAIGN_INFO"](state, payload) {
        state.candidateCampaignInfo = payload;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
